import { network } from 'services/network';

import { TBaselineComparable } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/ProjectPreferences/ProjectPreferences.utils';

export const setProgressPreferences = ({
    projectId,
    selectedOption,
}: {
    projectId: number;
    selectedOption: TBaselineComparable;
}) => {
    return network
        .post('api/bo/setProgressPreferences', { projectId, selectedOption })
        .then((response) => response.data);
};
